module.exports = __webpack_public_path__ + "img/g_elargisseur_ch_entraxe.23fc8613.jpg";